/* import __COLOCATED_TEMPLATE__ from './authentication-required.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { htmlSafe } from '@ember/template';
import Config from "../config/environment";

/**
 * This is a generic component that will prompt the user to login and redirect them to the current page after completion
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-authentication-required'],

  /**
   * Register services
   */

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * A function to implement on what to do after 'login to view' has been clicked
   *
   * @param {Function}
   */
  handleLoginToView: function() {
    throw new Error('no handle login defined');
  },

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /** @type {Ember.String.htmlSafe} */
  _backgroundImageStyle: computed('internalSrc', function () {
    const backgroundImageUri = Config.SH_CDN_STATIC_IMAGES_URL + '/photographer-looking.jpg'
    return htmlSafe(`background-image: url('${backgroundImageUri}')`);
  }),

  actions: {
    /**
     * Update the parents of this component
     */
    onLoginToViewClicked() {
      this.get('handleLoginToView')();
    }
  }
});
